// extracted by mini-css-extract-plugin
export default {"portal-container":"Portal_portal-container__fonJa","portal-content":"Portal_portal-content__oRtYr"};